/**
* @license lucide-solid v0.363.0 - ISC
*
* This source code is licensed under the ISC license.
* See the LICENSE file in the root directory of this source tree.
*/

// src/icons/arrow-left-right.tsx
import Icon from "../Icon";
var iconNode = [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
];
var ArrowLeftRight = (props) => <Icon {...props} name="ArrowLeftRight" iconNode={iconNode} />;
var arrow_left_right_default = ArrowLeftRight;
export {
  arrow_left_right_default as default
};
//# sourceMappingURL=arrow-left-right.jsx.map
